import ErrorBoundary from "../../components/common/ErrorBoundary";
import { Outlet } from "react-router";

const AppRootLayout = () => {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
};

export default AppRootLayout;